const appId = process.env.APP_ID || 'userportal';

export default {
  developmentMode: process.env.NODE_ENV !== 'production',
  app: {
    id: appId,
    host: process.env.HOST || 'localhost',
    port: process.env.PORT || 3004,
    interface: process.INTERFACE || '0.0.0.0',
    staticFolder: new URL(/* @vite-ignore */ './build', import.meta.url).pathname,
    sitemapsFolder: new URL(/* @vite-ignore */ '../sitemaps', import.meta.url).pathname,
    ssrCacheFolder: new URL(/* @vite-ignore */ '../ssr_cache', import.meta.url).pathname,
    entryPoint: new URL(/* @vite-ignore */ './build/index.html', import.meta.url).pathname
  },
  api: {
    protocol: process.env.REACT_APP_API_PROTOCOL || 'http',
    host: process.env.REACT_APP_API_HOST || 'localhost',
    port: process.env.REACT_APP_API_PORT || 3001,
    mountPath: process.env.REACT_APP_API_MOUNT_PATH || '/_api'
  },
  amqp: {
    connection: process.env.AMQP_CONNECTION || 'amqp://rabbitmq:rabbitmq@localhost:5672',
    exchangeName: 'skilleto',
    exchangeType: 'direct',
    updates: {
      queuePrefix: `${appId}_update_`,
      routingKey: `${appId}_update`
    },
    logging: true
  },
  jwt: {
    secret: process.env.JWT_SECRET || 'sample_secret',
  },
  ws: {
    path: process.env.WS_PATH || '/_ws',
    getCompanyRoomName(companyId) {
      return `company_${companyId}`;
    },
    getUserRoomName(userId) {
      return `user_${userId}`;
    }
  }
};
